import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import styles from "./priestScheduleReport.module.scss";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as XLSX from "xlsx";
import { isNil } from "lodash";
// import { CustomSelect, CustomInputLabel, CustomRadioButton, CommonButton, CustomMenuItem } from "components/common/StyledComponents/StyledFields";
// import { apiRequest } from "infrastructure/backendService";
import { apiRequest, getUserSelectedRole } from "../../../infrastructure/backendService";
import { CustomInputLabel, CustomRadioButton, CommonButton, CustomMenuItem, CustomCalendarTodayOutlinedIcon, CustomDatePicker, StyledDateContainer, CommonOutlinedButton } from "../../common/StyledComponents/StyledFields";
import { ClipLoader } from "react-spinners";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import stylesWeek from '../reportSection.module.scss'

const CustomSelect = styled(Select)`
& svg {
    color: #F05802;
 }
 & div {
    overflow: unset;
    padding: 14px 16px;
    height: 20px !important;
    min-height: 0px !important;
    border-radius: 8px;
    background: #fff;
    min-width: 0 !important;
 }
 & input {
    padding: 14px 16px;
    height: 20px;
    border-radius: 8px;
 }
 & fieldset {
    border-style: unset;
 }
`;


const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: "12px",
  borderCollapse: "collapse", // Collapse borders to avoid doubled borders between cells
 
  // textOrientation: "mixed", // Allows for upright text within vertical writing mode
}));
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  position: "relative",
  overflow: "auto",
  paddingBottom: "4px",
  borderRadius: "12px",
  
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#F2BE22", // Scrollbar color
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
  
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: " #F2BE22",
    fontWeight: "700",
    color: theme.palette.common.white,
    // writingMode: "horizontal-rl", // Vertical writing mode
    // textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "center",
    border: "1px solid #fff",
    padding: "10px",
    margin: "10px",

    // transform: "rotate(180deg)",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // whiteSpace: "pre-line",
    whiteSpace: "nowrap",
    textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    margin: 0,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  //   height: "-10px",
  "& td, & th": {
    margin: "10px",
    padding: "10px",
    border: "1px solid #fff",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: " #fff", // Set odd rows to white
  },
  "&:nth-of-type(even)": {
    backgroundColor: " #FFF9E4", // Set even rows to yellow
  },
}));

const IncomeReport = ({ sendDataToParent, getReportData,getReqBodyAndResData }:any) => {
  const currentDate = new Date();

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // var currentMonthNumber = currentDate.toLocaleDateString('en-US', { month: 'long' }).toUpperCase();
  var currentMonthNumber = currentDate.getMonth();

  let minDate:any;
  let maxDate:any;
  switch(getUserSelectedRole()){
    case 'Member Board of Directors':
    // case 'Corporate Secretary - BOD':
      minDate = dayjs().subtract(1, 'year').startOf('year'); // January 1st of last year
      maxDate = dayjs().endOf('year'); // December 31st of current year
    break;
    default:
      minDate = '';
      maxDate = '';
     break;   
  }

  const [selectedYear, setSelectedYear] = useState<any>(
    currentDate.getFullYear()
  );
  const [selectedMonthName, setSelectedMonthName] = useState<any>(
    currentMonthNumber
  );
  const getMostRecentMonday = () => {
    const today = dayjs();
    const dayOfWeek = today.day(); // day() returns 0 (Sunday) to 6 (Saturday)
    const lastMonday = today.subtract(dayOfWeek === 0 ? 6 : dayOfWeek - 1, 'day');
    return lastMonday.format("MM/DD/YYYY");
  };

  const [selectedQuater, setSelectedQuater] = useState<string>("");
  const [showMonthly, setShowMonthly] = useState<boolean>(false);
  const [showQuaterly, setShowQuaterly] = useState<boolean>(false);
  const [showYearly, setShowYearly] = useState<boolean>(false);
  const [showDaily, setShowDaily] = useState<boolean>(false);
  const [showCustomDate, setShowCustomDate] = useState<boolean>(false);
  const [occuranceType, setOccuranceType] = useState<string>("");
  const [errMessage, setErrMessage] = useState("");
  const [ReportData, setReportData] = useState<any[]>([]);
  // const [tableHeaders, setTableHeaders] = useState<any>({});
  const [searchButton, setSearchButton] = useState<boolean>(true);
  const [loading, setLoading] = useState(false);
  const [isAPICalled, setIsAPICalled] = useState(false);
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [tableData, setTabledata] = useState(false);
  const [tableHeaders, setColumnData] = useState<any>({});
  const [selectedWeek, setSelectedWeek] = useState(getMostRecentMonday());
  const [showWeekly, setShowWeekly] = useState<boolean>(false);
  const [selectedCustomDateFrom, setSelectedCustomDateFrom] = useState(dayjs().format("MM/DD/YYYY"));
  const [selectedCustomDateTo, setSelectedCustomDateTo] = useState(dayjs().format("MM/DD/YYYY"));
  const [Years, setYears] = useState<any>({});

  const [formData, setFormData] = useState<any>({
    date: dayjs(), // Initialize with empty string
  });
  const [errorMessage, setErrorMessage] = useState({
    date: "",
  });

  const handleFieldChange = (value: string) => {
     setFormData({
      ...formData,
        date:value, 
    });

    setSearchButton(false);
  };

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: "/report-dashboard/yearList/INCOME_REPORT",
      includeToken: true,
    })
      .then((res) => {
        setYears(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handlesubmit = () => {
    apiCall();
  };


  const apiCall = () => {
    setLoading(true);
    let reqBody: any = {};
    switch (occuranceType) {
      case "Daily":
        const formattedDate = formData.date && dayjs(formData.date).format("MM/DD/YYYY")
        reqBody.dailySearch = true;
        reqBody.searchStartDate = formattedDate;
        reqBody.searchEndDate = formattedDate;
        break;
      case "Weekly":
        reqBody.weeklySearch = true;
        reqBody.searchStartDate = selectedWeek;
        reqBody.searchEndDate = dayjs(selectedWeek, "MM/DD/YYYY").add(1, 'week').format("MM/DD/YYYY");

        break;
      case "Monthly":
        reqBody.monthlySearch = true;
        let monthStartDate = dayjs(new Date(selectedYear, selectedMonthName)).format("MM/DD/YYYY");
        let monthEndDate = dayjs(new Date(selectedYear, selectedMonthName + 1, 0)).format("MM/DD/YYYY");
        reqBody.searchStartDate = monthStartDate;
        reqBody.searchEndDate = monthEndDate;
        break;
      case "Yearly":
        let yearStartDate = dayjs(new Date(selectedYear, 0, 1)).format("MM/DD/YYYY");
        let yearEndDate = dayjs(new Date(selectedYear, 11, 31)).format("MM/DD/YYYY");
        reqBody.searchStartDate = yearStartDate;
        reqBody.searchEndDate = yearEndDate;
        reqBody.yearlySearch = true;
        break;
      case "CustomDate":
        reqBody.customSearch = true;
        reqBody.searchStartDate = selectedCustomDateFrom;
        reqBody.searchEndDate = selectedCustomDateTo;
        break;
      // Add cases for other types of searches if needed
      default:
        break;
    }
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: '/report-dashboard/reports/treasury/INCOME_REPORT/browser',
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res: any) => {
        setLoading(false);
        setSearchButton(true);
        setIsAPICalled(true);
        setFormData({ date: "" });
        sendDataToParent(true,{reqBody:reqBody,reportName:'IncomeReport'});
        getReportData(res.data);
        getReqBodyAndResData(reqBody,res.data)
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
        setErrMessage(
          isNil(err.response.data.errorMessage)
            ? `${err.message}`
            : `${err.response.data}`
        );
        setLoading(false);
        setIsAPICalled(true);
      });
  };


  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    setSearchButton(false);
    // Update state based on the selected radio button
    switch (selectedValue) {
      case "Daily":
        setShowDaily(true)
        setShowMonthly(false);
        setShowQuaterly(false);
        setShowYearly(false);
        // setSelectedMonthName(currentMonthNumber);
        setOccuranceType("Daily");
        setShowWeekly(false);
        setShowCustomDate(false);
        break;
      case "Weekly":
        setShowWeekly(true);
        setShowMonthly(false);
        setShowDaily(false);
        setShowQuaterly(false);
        setShowYearly(false);
        setShowCustomDate(false);
        setOccuranceType("Weekly");
        break;
      case "Monthly":
        setShowMonthly(true);
        setShowQuaterly(false);
        setShowDaily(false)
        setShowYearly(false);
        setSelectedYear(currentDate.getFullYear());
        setSelectedQuater("");
        setSelectedMonthName(currentMonthNumber);
        setOccuranceType("Monthly");
        setShowWeekly(false);
        setShowCustomDate(false);
        break;
      case "Search By Yearly":
        setShowMonthly(false);
        setShowQuaterly(false);
        setShowYearly(true);
        setShowDaily(false);
        setSelectedQuater("");
        setSelectedYear(currentDate.getFullYear());
        setSelectedMonthName(currentMonthNumber);
        setOccuranceType("Yearly");
        setShowWeekly(false);
        setShowCustomDate(false);
        break;
        case "CustomDate":
          setShowMonthly(false);
          setShowQuaterly(false);
          setShowYearly(false);
          setShowDaily(false);
          setShowCustomDate(true);
          setShowWeekly(false);
          setOccuranceType("CustomDate");
          break;
      default:
        setShowMonthly(false);
        setShowQuaterly(false);
        setShowYearly(false);
        setShowWeekly(false);
        setShowCustomDate(false);
        setSelectedQuater("");
        setSelectedYear(currentDate.getFullYear());
        setSelectedMonthName(currentMonthNumber);
    }
  };

  const handleYearChange = (event: SelectChangeEvent<unknown>) => {
    setSelectedYear(event.target.value as number);
    setSearchButton(false);
  };

  const handleMonthChange = (event: SelectChangeEvent<unknown>) => {
    setSelectedMonthName(event.target.value as number);
    setSearchButton(false);
  };

  const handleWeekChange = (value: any) => {
    const selectedWeek = dayjs(value, "MM/DD/YYYY").format("MM/DD/YYYY");
    setSelectedWeek(selectedWeek);
  }

  const handleCustomDateFromChange = (value: any) => {
    const selectedCustomDateFrom = dayjs(value, "MM/DD/YYYY").format("MM/DD/YYYY");
    setSelectedCustomDateFrom(selectedCustomDateFrom);
  }

  const handleCustomDateToChange = (value: any) => {
    const selectedCustomDateTo = dayjs(value, "MM/DD/YYYY").format("MM/DD/YYYY");
    setSelectedCustomDateTo(selectedCustomDateTo);
  }



  const YearsDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropdown}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="year"
          onChange={handleYearChange}
          value={selectedYear}
          MenuProps={{
            PaperProps: {
              sx: {
                border: '1px solid #F05802',
                '& ul': {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: 'auto',
                  minHeight: 'auto',
                  maxHeight: '300px',
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#F3C539',
                    borderRadius: '6px',
                  },
                },
              },
            },
          }}
        >
          {Years?.map((item:any, i:any) => (
            <CustomMenuItem value={item.year} key={i}>
              {item.year}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const MonthsDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropdown} >
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="month"
          onChange={handleMonthChange}
          value={selectedMonthName}
          MenuProps={{
            PaperProps: {
              sx: {
                border: '1px solid #F05802',
                '& ul': {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: 'auto',
                  minHeight: 'auto',
                  maxHeight: '300px',
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#F3C539',
                    borderRadius: '6px',
                  },
                },
              },
            },
          }}
        >
          {months.map((item, index) => (
            <CustomMenuItem value={index} key={index}>
              {item}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const monthlyComponent = () => {
    return (
      <Grid container spacing={2} className={styles.dropdownConatiner}>
        <Grid xs={12} sm={3} item>
          <CustomInputLabel>Month</CustomInputLabel>
          {MonthsDropdown()}
        </Grid>
        <Grid xs={12} sm={3} item>
          <CustomInputLabel>Year</CustomInputLabel>
          {YearsDropdown()}
        </Grid>
      </Grid>
    );
  };

  const yearlyComponent = () => {
    return (
      <Grid container spacing={2} sx={{ width: "100%" }} className={styles.dropdownConatiner}>
        <Grid xs={12} sm={3} item>
          <CustomInputLabel>Search By Yearly</CustomInputLabel>
          {YearsDropdown()}
        </Grid>
      </Grid>
    );
  };


  useEffect(() => {
    setDatePickerOpen(false);
  }, [formData.date]);

  const BasicDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer className={stylesWeek.styledConatiner}
          id="dob"
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs} >
            <DemoContainer components={["DateTimePicker"]} >
              <CustomDatePicker 
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM/DD/YYYY"
                value={formData.date}
                onChange={(value: any) => {
                  handleFieldChange(value);
                  setDatePickerOpen(false);
                }}
                minDate={minDate}
                maxDate={maxDate}
                referenceDate={dayjs()} // Ensure the picker opens to the current year
                views={['year', 'month', 'day']}
                className={
                  errorMessage.date
                    ? styles.errorDateFeild
                    : stylesWeek.dateFeildforfamily
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
        {errorMessage.date ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.date}
          </Typography>
        ) : (
          ""
        )}
      </div>
    );
  };

  const DatePickerWeekly = (): React.ReactElement => {
    return (
        <div className={styles.dateconatiner}>
            <StyledDateContainer className={stylesWeek.styledConatiner}
            >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DateTimePicker']}>
                        <CustomDatePicker
                            slots={{
                                openPickerIcon: CustomCalendarTodayOutlinedIcon,
                            }}
                            slotProps={{
                                inputAdornment: {
                                    position: 'end',
                                },
                            }}
                            format="MM/DD/YYYY"
                            value={
                                selectedWeek ? dayjs(selectedWeek, 'MM/DD/YYYY') : ''
                            }
                            onChange={(value) => {
                                handleWeekChange(value);
                            }}
                            disableFuture
                            minDate={minDate}
                            maxDate={maxDate}
                            referenceDate={dayjs()} // Ensure the picker opens to the current year
                            views={['year', 'month', 'day']}
                            className={stylesWeek.dateFeildforfamily}
                        />
                    </DemoContainer>
                </LocalizationProvider>
                {/* {errorMessageBookPooja.searchbydonation ? (
                    <Typography sx={{ color: 'red', fontSize: '12px' }}>
                        {errorMessageBookPooja.searchbydonation}
                    </Typography>
                ) : (
                    ''
                )} */}

            </StyledDateContainer>
        </div>
    );
};

const DatePickerCustomDateFrom = (): React.ReactElement => {
  return (
      <div className={styles.dateconatiner}>
          <StyledDateContainer className={stylesWeek.styledConatiner}
          >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DateTimePicker']}>
                      <CustomDatePicker
                          slots={{
                              openPickerIcon: CustomCalendarTodayOutlinedIcon,
                          }}
                          slotProps={{
                              inputAdornment: {
                                  position: 'end',
                              },
                          }}
                          format="MM/DD/YYYY"
                          value={
                            selectedCustomDateFrom ? dayjs(selectedCustomDateFrom, 'MM/DD/YYYY') : ''
                          }
                          onChange={(value) => {
                              handleCustomDateFromChange(value);
                          }}
                          disableFuture
                          minDate={minDate}
                          maxDate={maxDate}
                          referenceDate={dayjs()} // Ensure the picker opens to the current year
                          views={['year', 'month', 'day']}
                          className={stylesWeek.dateFeildforfamily}
                      />
                  </DemoContainer>
              </LocalizationProvider>
              {/* {errorMessageBookPooja.searchbydonation ? (
                  <Typography sx={{ color: 'red', fontSize: '12px' }}>
                      {errorMessageBookPooja.searchbydonation}
                  </Typography>
              ) : (
                  ''
              )} */}

          </StyledDateContainer>
      </div>
  );
};

const DatePickerCustomDateTo = (): React.ReactElement => {
  return (
      <div className={styles.dateconatiner}>
          <StyledDateContainer className={stylesWeek.styledConatiner}
          >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DateTimePicker']}>
                      <CustomDatePicker
                          slots={{
                              openPickerIcon: CustomCalendarTodayOutlinedIcon,
                          }}
                          slotProps={{
                              inputAdornment: {
                                  position: 'end',
                              },
                          }}
                          format="MM/DD/YYYY"
                          value={
                            selectedCustomDateTo ? dayjs(selectedCustomDateTo, 'MM/DD/YYYY') : ''
                          }
                          onChange={(value) => {
                              handleCustomDateToChange(value);
                          }}
                          disableFuture
                          minDate={minDate}
                          maxDate={maxDate}
                          referenceDate={dayjs()} // Ensure the picker opens to the current year
                          views={['year', 'month', 'day']}
                          className={stylesWeek.dateFeildforfamily}
                      />
                  </DemoContainer>
              </LocalizationProvider>
              {/* {errorMessageBookPooja.searchbydonation ? (
                  <Typography sx={{ color: 'red', fontSize: '12px' }}>
                      {errorMessageBookPooja.searchbydonation}
                  </Typography>
              ) : (
                  ''
              )} */}

          </StyledDateContainer>
      </div>
  );
};

  const dailyComponent = () => {
    return (
      <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={12} sm={3}>
                    <CustomInputLabel>Search By Daily</CustomInputLabel>
                    {BasicDatePicker()}
                </Grid>
            </Grid>
    );
  };

  const weeklyComponent = () => {
    return (
            <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={12} sm={3}>
                    <CustomInputLabel>Weekly</CustomInputLabel>
                    {DatePickerWeekly()}
                </Grid>
            </Grid>
    );
};

const customDateComponent = () => {
  return (
    <Grid container spacing={2} sx={{ mt: 0 }}>
      <Grid item xs={12} sm={3}>
          <CustomInputLabel>Custom Dates From</CustomInputLabel>
          {DatePickerCustomDateFrom()}
      </Grid>
      <Grid item xs={12} sm={3}>
          <CustomInputLabel>Custom Dates To</CustomInputLabel>
          {DatePickerCustomDateTo()}
      </Grid>
</Grid>
  );
}



  const radioButtonsComponent = () => {
    return (
      <Box sx={{ marginBottom: "16px", display: "flex", flexDirection: "row" }}>
        <FormControlLabel
          value="Daily"
          control={
            <CustomRadioButton
              checked={showDaily}
              onChange={handleRadioChange}
            />
          }
          label="Daily"
        />
        <FormControlLabel
          value="Weekly"
          control={
              <CustomRadioButton 
              checked={showWeekly}
              onChange={handleRadioChange}
              />
          }
          label="Weekly"
        />
        <FormControlLabel
          value="Monthly"
          control={
            <CustomRadioButton
              checked={showMonthly}
              onChange={handleRadioChange}
            />
          }
          label="Monthly"
        />
        {/* <FormControlLabel
          value="Search By Quarterly"
          control={
            <CustomRadioButton
              checked={showQuaterly}
              onChange={handleRadioChange}
            />
          }
          label="Search By Quarterly"
        /> */}
        <FormControlLabel
          value="Search By Yearly"
          control={
            <CustomRadioButton
              checked={showYearly}
              onChange={handleRadioChange}
            />
          }
          label="Yearly"
        />
        <FormControlLabel
          value="CustomDate"
          control={
            <CustomRadioButton
              checked={showCustomDate}
              onChange={handleRadioChange}
            />
          }
          label="Custom Dates"
        />
      </Box>
    );
  };

  const handleGoingBackToMainReportsSection = () => {
    setTabledata(false);
  }

  const renderData = () => {
    return (
      <>
        <CommonOutlinedButton onClick={handleGoingBackToMainReportsSection}> Back to Pooja Reports</CommonOutlinedButton>
        <StyledTableContainer sx={{ width: "100%" }}>
          <StyledTable aria-label="customized table">
            <TableHead>
              <TableRow>
                {Object.values(tableHeaders).map((header: any) => (
                  <StyledTableCell align="center" key={header}>
                    <div dangerouslySetInnerHTML={{ __html: header }} />
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {ReportData.map((item, index) => (
                <StyledTableRow key={index}>
                  {Object.keys(tableHeaders).map((column) => (
                    <StyledTableCell key={column}>
                      {/* Check if the column corresponds to an array field */}
                      {column in item && Array.isArray(item[column]) ? (
                        // If it does, render each item in the array
                        <div>
                          {item[column].map((subItem: any, subIndex: any) => (
                            <div key={subIndex} style={{textTransform:"capitalize",alignItems:"flex-start",verticalAlign:"top"}}>
                              {/* Display title and amount */}
                              {subItem.title}: ${subItem.amount.toFixed(2)}
                            </div>
                          ))}
                        </div>
                      ) : (
                        // If it's not an array field, display the regular data
                        <div style={{textTransform:"capitalize",alignItems:"flex-start",verticalAlign:"top"}} dangerouslySetInnerHTML={{ __html: item[column] }} />
                      )}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))}

            </TableBody>
          </StyledTable>
        </StyledTableContainer>
      </>
    );
  };

  const handleClear = () => {
    setFormData({
     date:""
    });
    setSelectedMonthName("");
    setSelectedYear("");
    setSelectedWeek("");
    setSelectedCustomDateTo("");
    setSelectedCustomDateFrom("");
  }

  const renderComponent = () => {
    return (
      <>
        {showDaily ? dailyComponent() : ""}
        {showWeekly ? weeklyComponent() : ""}
        {showMonthly ? monthlyComponent() : ""}
        {/* {showQuaterly ? quaterlyComponent() : ""} */}
        {showYearly ? yearlyComponent() : ""}
        {showCustomDate ? customDateComponent() : ""}
      </>
    );
  };

  const reportComponent = () => {
    return (
      <>
        {ReportData.length > 0 ? (
          renderData()
        ) : (
          isAPICalled && <Typography component={"h3"}>No Data</Typography>
        )}
      </>
    );
  };

  return (
        <div>
          {radioButtonsComponent()}
          {renderComponent()}
          <Box sx={{ display: "flex", alignItems: "center", gap: "16px",mt:"16px" }}>
            <CommonButton
              className={styles.search}
              onClick={handlesubmit}
              disabled={searchButton || loading}
              id="search"
            >
              {loading ? (
                <>
                  <ClipLoader color="#fff" loading={loading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                "Submit"
              )}
            </CommonButton>
            <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
            
          </Box> 
          </div>
  );
};

export default IncomeReport;
